{
  "name": "@papra/api-sdk",
  "type": "module",
  "version": "1.1.3",
  "description": "Api SDK for Papra, the document archiving platform.",
  "author": "Corentin Thomasset <corentinth@proton.me> (https://corentin.tech)",
  "license": "AGPL-3.0-or-later",
  "repository": {
    "type": "git",
    "url": "https://github.com/papra-hq/papra",
    "directory": "packages/api-sdk"
  },
  "bugs": {
    "url": "https://github.com/papra-hq/papra/issues"
  },
  "keywords": [
    "papra",
    "api",
    "sdk",
    "document",
    "archiving",
    "storage"
  ],
  "exports": {
    ".": "./dist/index.js",
    "./package.json": "./package.json"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "files": [
    "dist"
  ],
  "scripts": {
    "lint": "eslint .",
    "lint:fix": "eslint --fix .",
    "test": "vitest run --passWithNoTests",
    "test:watch": "vitest watch",
    "typecheck": "tsc --noEmit",
    "build": "tsdown",
    "build:watch": "tsdown --watch",
    "dev": "pnpm build:watch",
    "prepublishOnly": "pnpm run build"
  },
  "dependencies": {
    "@corentinth/chisels": "catalog:",
    "ofetch": "^1.4.1"
  },
  "devDependencies": {
    "@antfu/eslint-config": "catalog:",
    "eslint": "catalog:",
    "tsdown": "catalog:",
    "typescript": "catalog:",
    "vitest": "catalog:"
  }
}
